import { render, staticRenderFns } from "./handover.vue?vue&type=template&id=caef1f7c&scoped=true&"
import script from "./handover.vue?vue&type=script&lang=js&"
export * from "./handover.vue?vue&type=script&lang=js&"
import style0 from "./handover.vue?vue&type=style&index=0&id=caef1f7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caef1f7c",
  null
  
)

export default component.exports